import { BpkInlineLogo } from '@skyscanner-internal/bpk-logos';

import type { Configs } from '@shared/types/configs';

import { withConfiguration } from '@shared/utils-frontend/contexts/ConfigurationContext';

type Props = {
  configs: Configs;
  className?: string;
  id?: string;
};

const SkyscannerLogo = ({ configs, ...props }: Props) => (
  <BpkInlineLogo aria-hidden="true" {...props} />
);

export default withConfiguration(SkyscannerLogo);
